import { ArrowRight } from "lucide-react";
import { SectionHeaderProps } from "@/types/AppTypes";
import { Link } from "react-router-dom";

const SectionHeader = ({
  heading = "",
  rightLink = "",
  rightLinkText = "",
  icon,
}: SectionHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-6 px-6">
      <h2 className="text-lg md:text-2xl  font-semibold">{heading}</h2>
      <Link to={rightLink} className="text-sm md:text-base flex items-center text-palette-primary">
        {rightLinkText} {icon ? icon : <ArrowRight className="ml-1 h-4 w-4" />}
      </Link>
    </div>
  );
};

export default SectionHeader;
